<template>
  <div>
      <menu class="menu-bar">
        <a href="javascript:void(0);" v-click-outside="hide" @click="toggle" class="toggle-menu">
          <div :class="open?'active':'inactive'"><span class="bar bar1"></span><span class="bar"></span><span class="bar bar3"></span></div>
        </a>
        <a href="/dashboard" class="logo">
          <!-- <i class="icon-logo"></i> -->
          <img src="https://static.sanar.sa/images/static/logo.svg" alt="logo" />
        </a>
      </menu>
      <transition slide="right" type="animation" name="slide">
      <side-bar :class="open? 'active':''" />
      </transition>
      <nav v-bind:class="isSubmenuFunc ?  'nav-bar' : 'nav-bar-none'">
        <template v-if="isSubmenuFunc">
          <a href="/dashboard" class="logo hidden-xs-only">
            <!-- <i class="icon-sanar"></i> -->
            <img src="https://static.sanar.sa/images/static/logo.svg" alt="logo" />
          </a>
          <sub-menu />
        </template>
      </nav>
  </div>
</template>
<script>
import ClickOutside from 'vue-click-outside'
import SideBar from '../SideBar.vue'
import Submenu from '../Submenu.vue'
export default {
  components:{
    'side-bar':SideBar,
    'sub-menu':Submenu,
  },
  data () {
    return {
      open: false
    }
  },
  methods: {
    hide () {
      this.open = false
    },
    toggle() {
    	this.open = !this.open
    },
  },
  mounted () {
      this.popupItem = this.$el
  },
  directives: {
    ClickOutside
  },
  computed:{
    isSubmenuFunc:function(){
      return this.$store.getters['uicomponents/isSubmenu'];
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/Navigation.vue